import React, { Component } from "react";
import Recaptcha from "react-recaptcha";

import Sunset from "../components/Sunset";

import "../styles/Contact.css";

const encode = data => {
    return Object.keys(data)
        .map(
            key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
        )
        .join("&");
};

class Contact extends Component {
    state = {
        name: "",
        email: "",
        subject: "",
        message: "",
        isVerified: false,
    };

    handleSubmit = e => {
        e.preventDefault();
        const { name, email, subject, message } = this.state;

        if (this.state.isVerified) {
            fetch("/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: encode({
                    "form-name": "contact",
                    name: name,
                    email: email,
                    subject: subject,
                    message: message,
                }),
            })
                .then(() => alert("You have successfully sent your message!"))
                .catch(error => alert(error));
            this.setState({
                name: "",
                email: "",
                subject: "",
                message: "",
                isVerified: false,
            });
        } else {
            alert("Please verify that you are a human!");
        }
    };

    recaptchaLoaded = () => {
        console.log("Recaptcha has successfully loaded.");
    };

    verifyCallback = response => {
        if (response) {
            this.setState({
                isVerified: true,
            });
        }
    };

    handleChange = e => this.setState({ [e.target.name]: e.target.value });

    render() {
        const { name, email, subject, message } = this.state;
        return (
            <div>
                <Sunset />
                <form
                    className="contact-form mt-5 px-3"
                    onSubmit={this.handleSubmit}
                >
                    <div className="mt-5 mb-5">
                        <div className="email-message">
                            For all inquiries please use the email address or
                            form provided below.
                        </div>
                        <div className="mr-1 email">
                            professorjonesmusic@gmail.com
                        </div>
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            name="name"
                            className="form-control my-3 mt-4"
                            placeholder="Name"
                            value={name}
                            onChange={this.handleChange}
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            className="form-control my-3"
                            placeholder="Email"
                            value={email}
                            onChange={this.handleChange}
                            required
                        />
                        <input
                            type="text"
                            name="subject"
                            className="form-control my-3"
                            placeholder="Subject"
                            value={subject}
                            onChange={this.handleChange}
                            required
                        />
                        <textarea
                            type="text-area"
                            rows="5"
                            name="message"
                            className="form-control my-3"
                            placeholder="Message"
                            value={message}
                            onChange={this.handleChange}
                            required
                        />
                    </div>
                    <div className="d-flex justify-content-center mb-3">
                        <Recaptcha
                            render="explicit"
                            sitekey="6LfUVGQUAAAAADUt4GriIWf5et9mzvzsLBnmfar_"
                            onloadCallback={this.recaptchaLoaded}
                            verifyCallback={this.verifyCallback}
                            theme="dark"
                        />
                    </div>
                    <button
                        type="submit"
                        className="btn btn-lg border border-warning submit-button"
                    >
                        SEND
                    </button>
                </form>
            </div>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js